import * as React from 'react';
import style from './TableColumn.scss';

export const TableColumn = ({
  children,
  index,
  tableDepth,
  ...props
}: {
  children?: any;
  index: number;
  tableDepth?: number;
}) => {
  const columnWidth =
    tableDepth && index === 1 ? style[`table-column-width-${tableDepth}`] : '';
  return (
    <span
      role="cell"
      className={`${style.col} ${style[`col-${index}`]}  ${columnWidth}`}
      {...props}
    >
      {children}
    </span>
  );
};
